module.exports = __webpack_public_path__ + "img/WX_Service.7847c464.png";